export default "__VITE_ASSET__45e26769__"